import setupFavoritePersona from './setupFavoritePersona';
import datapoints from '../../../datapoints';
import {
    getFavoritePersonasRootFolderId,
    retrievePersonaSearchFolders,
} from 'owa-mail-persona-search-folder-services';
import { Folder } from 'owa-folders';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { trace } from 'owa-trace';
import { logUsage } from 'owa-analytics';

import { getStore } from 'owa-mail-favorites-store';

export default createLegacyActionWithDatapoint(
    'initializeFavoritePersonas',
    datapoints.InitializeFavoritePersonasAction
)(async function initializeFavoritePersonas(personaIds: string[]) {
    // This will create root favorite personas folder
    const parentFolderId = await getFavoritePersonasRootFolderId();
    getStore().favoritePersonasRootFolderId = parentFolderId;
    await setupPersonasSearchFolders(parentFolderId, personaIds);
});

function setupPersonasSearchFolders(parentFolderId: string, personaIds: string[]): Promise<void> {
    return retrievePersonaSearchFolders(personaIds, parentFolderId)
        .then(personaSearchFolders => {
            personaSearchFolders.forEach((personaSearchFolder: Folder) => {
                setupFavoritePersona(personaSearchFolder);
            });
        })
        .catch(error => {
            const eventName = 'RetrievePersonaSearchFoldersFailed';
            trace.warn(eventName + ': ' + error);
            logUsage(eventName, [error.toString()]);
        });
}
